import { partial } from '../../util/translation/translation';

const p = partial('appLayout');
const warned = new Set();

// "playerStats" / "goal-sponsor" / "specific-news" -> "Player stats" /
// "Goal sponsor" / "Specific news"
const humanize = (id) => {
  const words = `${id}`
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[-_]+/g, ' ')
    .trim()
    .toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/**
 * A layout component's name from appLayout.<id>. The backend can return ids
 * without a translation yet; in development a missing key throws, which
 * would take the whole drag-and-drop down, so fall back to a readable name
 * made from the id (and warn once, so the key still gets added).
 */
const componentName = (id) => {
  try {
    return p(id);
  } catch {
    if (process.env.NODE_ENV === 'development' && !warned.has(id)) {
      warned.add(id);
      console.warn(`Missing translation for appLayout.${id}`);
    }
    return humanize(id);
  }
};

export default componentName;
